module.exports = __webpack_public_path__ + "img/step41_a_remove_endcaps.5ded4986.png";